import { css } from '@bts-web/utils-style-engine';

export const stepContainerStyles = css({
  width: '100%',
  display: 'flex',
  flexDir: 'column',
  flex: {
    base: 'auto',
    ['lg' as string]: '1',
  },
  overflow: 'hidden',
});
